<template>
  <div class="demandReport" id="taskPlanContainer">
    <div class="leftDiv">
      <div class="leftTopDiv">
        <div class="userInfoClass">
          <div class="photo">
            <img v-if="userInfo.iconUrl" :src="userInfo.iconUrl" />
          </div>
          <div class="basicInfo">
            <tooltip-over
              :content="userInfo.username"
              :className="'username'"
              class="wid190"
              refName="username"
            ></tooltip-over>
            <div class="line"></div>
            <tooltip-over
              :content="'账号:' + userInfo.userNo"
              :className="'userNo'"
              class="wid190"
              refName="userNo"
            ></tooltip-over>
            <tooltip-over
              :content="userInfo.departmentName"
              :className="'departmentName'"
              class="wid190"
              refName="departmentName"
            ></tooltip-over>
            <tooltip-over
              :content="userInfo.roleName"
              :className="'roleName'"
              class="wid190"
              refName="roleName"
            ></tooltip-over>
          </div>
          <div class="logOut" @click="logOut()"></div>
        </div>
        <div class="statistics">
          <div class="waitConfirm" :style="opacityOfWaitConfirm" @click="waitConfirm">
            <div class="title">待确认</div>
            <div class="num">{{ waitConfirmNum }}</div>
          </div>
          <div class="confirm" :style="opacityOfConfirm" @click="confirm">
            <div class="title">已通过</div>
            <div class="num">{{ confirmNum }}</div>
          </div>
          <div class="rejected" :style="opacityOfRejected" @click="rejected">
            <div class="title">驳回</div>
            <div class="num">{{ rejectedNum }}</div>
          </div>
        </div>
      </div>
      <div class="leftBottomDiv">
        <div class="contentClass">
          <!-- <div class="tableTitle">
            <div class="title">任务计划列表</div>
            <div class="chooseStatus" v-show="isConfirm">
              <el-select
                @change="getConfirmRelationListByEvnConfirmed()"
                popper-class="selectPopperClass"
                v-model="queryForm.flight_status"
              >
                <el-option
                  v-for="flightStatus in flightStatuses"
                  :key="flightStatus.id"
                  :label="flightStatus.name"
                  :value="flightStatus.id"
                />
              </el-select>
            </div>
          </div> -->
          <div>
            <el-table
              :data="taskPlanList"
              @row-click="clickTaskPlanRow"
              ref="taskPlanList"
              height="384"
              :row-style="{ height: '40px' }"
              :cell-style="changeCellStyle"
              :row-class-name="tableRowClassName"
              style="width: 92%"
              tooltip-effect="light"
              class="taskTable"
            >
              <el-table-column
                prop="flight_local_id"
                label="计划编号"
                min-width="80"
                :show-overflow-tooltip="true"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="flight_name"
                label="计划名称"
                align="center"
                min-width="100"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                label="优先级"
                align="center"
                min-width="60"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.flight_pirority === 1">低</span>
                  <span v-else-if="scope.row.flight_pirority === 2">中</span>
                  <span v-else-if="scope.row.flight_pirority === 3">高</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="flight_status"
                label="当前状态"
                align="center"
                min-width="60"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.flight_status === 10">规划中</span>
                  <span v-else-if="scope.row.flight_status === 15"
                    >已提交/待环境确认</span
                  >
                  <span v-else-if="scope.row.flight_status === 20">待审核</span>
                  <span v-else-if="scope.row.flight_status === 30">驳回</span>
                  <span v-else-if="scope.row.flight_status === 40">审批通过</span>
                  <span v-else-if="scope.row.flight_status === 50">待飞行</span>
                  <span v-else-if="scope.row.flight_status === 60">正在飞行</span>
                  <span v-else-if="scope.row.flight_status === 70">飞行结束</span>
                  <span v-else-if="scope.row.flight_status === 90">确认收货</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="searchArea">
            <div class="desc">计划搜索</div>
            <div class="separate"></div>
            <el-form :model="queryForm" @submit.native.prevent>
              <el-form-item label="">
                <el-input
                  class="inputClass"
                  v-model="queryForm.condition"
                  @keyup.enter.native="getConfirmRelationListByEvnConfirmed()"
                >
                  <i
                    class="el-icon-search-img"
                    slot="suffix"
                    @click="getConfirmRelationListByEvnConfirmed()"
                  >
                  </i></el-input
              ></el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div class="taskPlanCenterDiv" v-show="isDetail">
      <div class="taskPlanCenterTopDiv">
        <div class="taskPlanFormTitle">
          <div class="leftTitle">
            <div class="localId">
              {{ flight.local_id }}
            </div>
            <div class="planCodeName">计划编号</div>
            <div class="seperator">-</div>
          </div>
          <div class="rightPriority">
            <img v-if="null !== priority" :src="priority" :class="priorityClass" />
          </div>
        </div>

        <div v-show="isDetail">
          <div class="seperate"></div>
          <div class="taskPlanCreateInfo">
            <div class="label">创建时间:</div>
            <div class="content">{{ flight.created_at }}</div>
            <div class="label">提交账号:</div>
            <div class="content">{{ applyer.userNo }}</div>
          </div>
          <div class="seperate"></div>
        </div>

        <div class="formTaskPlanDetailContainer">
          <el-form
            id="taskPlanForm"
            ref="taskPlanForm"
            :model="flight"
            class="taskPlanForm"
          >
            <el-collapse v-model="activeAccordionName" accordion>
              <el-collapse-item name="deliveryTime" class="deliveryTimeClass">
                <template slot="title">
                  <i class="header-icon el-icon-delivery-time"></i>投送时间
                </template>
                <div class="taskPlanItemContainer">
                  <el-form-item class="leftHalfItem" label="开始时间:">
                    <div class="content">{{ flight.start_at }}</div>
                  </el-form-item>

                  <el-form-item class="rightHalfItem" label="结束时间:">
                    <div class="content">{{ flight.end_at }}</div>
                  </el-form-item>
                </div> </el-collapse-item
              ><el-collapse-item name="limitTime" class="otherItemClass">
                <template slot="title">
                  <i class="header-icon el-icon-limit-time"></i>是否限时
                </template>
                <div class="taskPlanItemContainer">
                  <el-form-item class="leftHalfItem" label="是否限时:">
                    <div class="content">
                      <div v-if="flight.is_limit === 1">是</div>
                      <div v-else>否</div>
                    </div>
                  </el-form-item>

                  <div v-show="flight.is_limit === 1">
                    <el-form-item class="rightHalfItem" label="到期时间:">
                      <div class="content">
                        {{ flight.limit_time }}
                      </div></el-form-item
                    >
                  </div>
                </div> </el-collapse-item
              ><el-collapse-item name="insuredValue" class="otherItemClass">
                <template slot="title">
                  <i class="header-icon el-icon-insured-value"></i>保价金额
                </template>
                <div class="taskPlanItemContainer">
                  <el-form-item class="f2Class" label="保价金额:"
                    ><div class="content">{{ flight.f2 }} &nbsp;元</div>
                  </el-form-item>
                </div> </el-collapse-item
              ><el-collapse-item name="linkPlanning" class="linkItemClass">
                <template slot="title">
                  <i class="header-icon el-icon-link-planning"></i>链路规划
                </template>

                <div class="linkClass">
                  <div class="taskPlanItemContainer">
                    <el-form-item class="leftHalfItem" label="链路型号:">
                      <div class="content">
                        {{ airlink.name }}
                      </div>
                    </el-form-item>
                    <el-form-item class="rightHalfItem" label="链路类型:">
                      <div class="content">
                        <div v-if="airlink.type === 0">M4G</div>
                        <div v-else-if="airlink.type === 1">J4G</div>
                        <div v-else-if="airlink.type === 2">M5G</div>
                        <div v-else-if="airlink.type === 3">J5G</div>
                        <div v-else-if="airlink.type === 4">电台</div>
                        <div v-else-if="airlink.type === 5">卫通</div>
                      </div>
                    </el-form-item>

                    <el-form-item class="leftHalfItem lastFormItemRow" label="链路频点:">
                      <div class="content">
                        {{ airlink.frequency }}
                      </div>
                    </el-form-item>
                    <el-form-item class="rightHalfItem lastFormItemRow" label="通讯站:">
                      <div class="content">
                        {{ airlink.com_station_name }}
                      </div>
                    </el-form-item>
                  </div>
                </div> </el-collapse-item
              ><el-collapse-item name="designatedPersonnel" class="userItemClass">
                <template slot="title">
                  <i class="header-icon el-icon-designated-personnel"></i>指派人员
                </template>
                <div class="linkClass">
                  <div class="taskPlanItemContainer">
                    <el-form-item class="leftHalfItem" label="发货地勤:">
                      <div class="content">
                        {{ customer_groundstaf.username }}
                      </div>
                    </el-form-item>
                    <el-form-item class="rightHalfItem" label="保障员:">
                      <div class="content">
                        {{ security.username }}
                      </div>
                    </el-form-item>

                    <el-form-item class="leftHalfItem" label="收货地勤:">
                      <div class="content">
                        {{ destination_groundstaf.username }}
                      </div>
                    </el-form-item>
                    <el-form-item class="rightHalfItem" label="审核员:">
                      <div class="content">
                        {{ auditor.username }}
                      </div>
                    </el-form-item>
                    <el-form-item class="leftHalfItem lastFormItemRow" label="任务控制:">
                      <div class="content">
                        {{ task_controller.username }}
                      </div>
                    </el-form-item>
                    <el-form-item class="rightHalfItem lastFormItemRow" label="飞手:">
                      <div class="content">
                        {{ flyer.username }}
                      </div>
                    </el-form-item>
                  </div>
                </div></el-collapse-item
              ><el-collapse-item name="taskplanPoint" class="otherItemClass">
                <template slot="title">
                  <i class="header-icon el-icon-taskplan-point"></i>驻点选择
                </template>
                <div class="linkClass">
                  <div class="taskPlanItemContainer">
                    <el-form-item class="leftHalfItem" label="起点名称:">
                      <div class="content">
                        {{ starstaypoint.name }}
                      </div>
                    </el-form-item>
                    <el-form-item class="rightHalfItem" label="起点高度:">
                      <div class="content">{{ starstaypoint.altitude }} &nbsp;m</div>
                    </el-form-item>

                    <el-form-item class="leftHalfItem" label="起点经度:">
                      <div class="content">
                        {{ starstaypoint.longitude }}
                      </div>
                    </el-form-item>
                    <el-form-item class="rightHalfItem" label="起点纬度:">
                      <div class="content">
                        {{ starstaypoint.latitude }}
                      </div>
                    </el-form-item>

                    <el-form-item class="leftHalfItem" label="终点名称:">
                      <div class="content">
                        {{ endstaypoint.name }}
                      </div>
                    </el-form-item>
                    <el-form-item class="rightHalfItem" label="终点高度:">
                      <div class="content">{{ endstaypoint.altitude }}&nbsp;m</div>
                    </el-form-item>

                    <el-form-item class="leftHalfItem lastFormItemRow" label="终点经度:">
                      <div class="content">
                        {{ endstaypoint.longitude }}
                      </div>
                    </el-form-item>
                    <el-form-item class="rightHalfItem lastFormItemRow" label="终点纬度:">
                      <div class="content">
                        {{ endstaypoint.latitude }}
                      </div>
                    </el-form-item>
                  </div>
                </div></el-collapse-item
              ><el-collapse-item name="routePlanning" class="otherItemClass">
                <template slot="title">
                  <i class="header-icon el-icon-route-planning"></i>航路规划
                </template>
                <div class="linkClass">
                  <div class="taskPlanItemContainer">
                    <el-form-item class="leftHalfItem" label="编号:">
                      <div class="content">
                        {{ flight.airline_name }}
                      </div>
                    </el-form-item>
                    <el-form-item class="rightHalfItem" label="航向长度:">
                      <div class="content">{{ flight.total_mileage }}&nbsp;km</div>
                    </el-form-item>

                    <el-form-item class="leftHalfItem lastFormItemRow" label="飞行高度:">
                      <div class="content">{{ flight.average_altiude }}&nbsp;m</div>
                    </el-form-item>
                    <el-form-item class="rightHalfItem lastFormItemRow" label="航点数:">
                      <div class="content">{{ flight.point_count }}</div>
                    </el-form-item>
                  </div>
                </div> </el-collapse-item
              ><el-collapse-item name="uavSelect" class="otherItemClass">
                <template slot="title">
                  <i class="header-icon el-icon-uav-select"></i>无人机选择
                </template>

                <div class="linkClass">
                  <div class="taskPlanItemContainer">
                    <el-form-item class="leftHalfItem" label="飞机名称:">
                      <div class="content">
                         <el-tooltip
                          class="item"
                          effect="light"
                          v-if="uav.name"
                          :content="uav.name"
                          placement="top"
                          :disabled="uav.name.length <= 10"
                        >
                          <span> {{ uav.name.length > 10 ?  uav.name.slice(0, 10) + '...' : uav.name}} </span>
                        </el-tooltip>
                      </div>
                    </el-form-item>
                    <el-form-item class="rightHalfItem" label="最大载重:">
                      <div class="content">{{ uav.uavmodel.max_payload }}&nbsp;kg</div>
                    </el-form-item>

                    <el-form-item class="leftHalfItem" label="货舱体积:">
                      <div class="content">
                        {{ uav.uavmodel.cargo_hold_volume }}&nbsp;cm3
                      </div>
                    </el-form-item>
                    <el-form-item class="rightHalfItem" label="满载航时:">
                      <div class="content">{{ uav.uavmodel.max_fly_time }}&nbsp;min</div>
                    </el-form-item>

                    <el-form-item class="leftHalfItem" label="机载通讯:">
                      <div class="content">
                        {{ uav.airborne_communication_name }}
                      </div>
                    </el-form-item>
                    <el-form-item class="rightHalfItem" label="生产厂商:">
                      <div class="content">
                         <el-tooltip
                          class="item"
                          effect="light"
                          v-if="uav.uavmodel.company_name"
                          :content="uav.uavmodel.company_name"
                          placement="top"
                          :disabled="uav.uavmodel.company_name.length <= 10"
                        >
                          <span> {{ uav.uavmodel.company_name.length > 10 ?  uav.uavmodel.company_name.slice(0, 10) + '...' : uav.uavmodel.company_name}} </span>
                        </el-tooltip>
                      </div>
                    </el-form-item>

                    <el-form-item
                      class="leftHalfItem"
                      prop=""
                      label-width="8px"
                      style="margin-top: 13px"
                    >
                      <el-checkbox
                        v-model="flight.is_target"
                        disabled
                        class="taskPlan-checkbox"
                        :true-label="1"
                        :false-label="0"
                        >是否需要降落引导目标</el-checkbox
                      >
                    </el-form-item>

                    <el-form-item
                      class="leftHalfItem lastFormItemRow"
                      prop=""
                      label-width="8px"
                      style="width: 100%; height: 70px; margin-top: 7px"
                      v-show="1 == flight.is_target"
                    >
                      <img
                        class="parkingApronImg"
                        :src="
                          1 == flight.target_icon ? parkingApron1Hover : parkingApron1
                        "
                      /><img
                        class="parkingApronImg"
                        :src="
                          2 == flight.target_icon ? parkingApron2Hover : parkingApron2
                        "
                      />
                    </el-form-item>
                  </div>
                </div>
              </el-collapse-item>
              <!-- 添加计划流转信息 -->
              <el-collapse-item name="planCirculationInfo">
                <template slot="title">
                  <i class="header-icon el-icon-plan-cir-info"></i>计划流转信息
                </template>
              </el-collapse-item>
            </el-collapse>
          </el-form>
        </div>
      </div>
    </div>
    <div class="rightDiv" v-show="isDetail">
      <div
        class="planCirculationTimelineBox"
        v-if="activeAccordionName === 'planCirculationInfo'"
      >
        <div class="planCirculationTimelineBoxTitle">计划流转信息</div>
        <div :class="['planCirculationTimelineBoxContent', isConfirm ? 'isConfirm' : '']">
          <el-timeline class="planCirculationTimelineBoxContentInfo" :reverse="true">
            <el-timeline-item
              placement="top"
              v-for="(planCirculationInfo, index) in planCirculationInfos"
              :class="index === planCirculationInfos.length - 1 ? 'fontFFA63E' : ''"
              :key="index"
              :icon="index === planCirculationInfos.length - 1 ? 'el-icon-check' : ''"
              :color="index === planCirculationInfos.length - 1 ? '#FFA63E' : '#fff'"
              :size="index === planCirculationInfos.length - 1 ? 'large' : 'normal'"
              :timestamp="planCirculationInfo.timestamp"
            >
              {{ planCirculationInfo.content }}
            </el-timeline-item>
          </el-timeline>
        </div>
         <div class="rightBottomDiv" v-show="!isConfirm">
          <el-button class="saveButton" v-if="isDetail" @click="adopt()"> 通过</el-button>
          <el-button class="rejectButton" v-if="isDetail" @click="reject()">
            驳回</el-button
          >
        </div>
      </div>

      <div class="goodsListAndNote" v-else>
        <div :class="rightTopDiv">
          <div class="rightMainContainer">
            <div class="rightCommonTitle">
              <div class="title">
                <i class="header-icon el-icon-goods-plan"></i>
                &nbsp;货物列表
              </div>
              <div class="title">货物名称:&nbsp;&nbsp;{{ goodsName }}</div>
            </div>
            <el-table
              :data="goodsList"
              class="goodsList"
              ref="goodsList"
              :height="goodsListHeight"
              :row-style="{ height: '40px' }"
              :cell-style="changeCellStyle"
              :row-class-name="goodsListRowClassName"
              tooltip-effect="light"
            >
              <el-table-column
                label="序号"
                align="center"
                prop="index"
                min-width="60"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="local_id"
                label="货物编号"
                align="center"
                min-width="150"
                :show-overflow-tooltip="true"
              >
              </el-table-column
              ><el-table-column
                label="体积（长*宽*高）/cm"
                align="center"
                min-width="180"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.goods_length }}* {{ scope.row.goods_width }}*
                    {{ scope.row.goods_height }}
                  </span>
                </template></el-table-column
              ><el-table-column
                label="重量/kg"
                align="center"
                min-width="80"
                prop="goods_weight"
                :show-overflow-tooltip="true"
              ></el-table-column
              ><el-table-column
                label="属性"
                min-width="220"
                align="center"
                prop="attributes"
                :show-overflow-tooltip="true"
              ></el-table-column
              ><el-table-column
                label="类型"
                align="center"
                prop="goods_type_name"
                min-width="80"
                :show-overflow-tooltip="true"
              ></el-table-column
              ><el-table-column
                label="包装"
                align="center"
                min-width="100"
                prop="goods_package_name"
                :show-overflow-tooltip="true"
              ></el-table-column
              ><el-table-column
                label="密级"
                align="center"
                min-width="60"
                prop="goods_secrecy_id"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.goods_secrecy_id === 0">非<span>密</span></span>
                  <span v-else-if="scope.row.goods_secrecy_id === 1"
                    >秘<span>密</span></span
                  >
                  <span v-else-if="scope.row.goods_secrecy_id === 2"
                    >机<span>密</span></span
                  ><span v-else-if="scope.row.goods_secrecy_id === 3"
                    >绝<span>密</span></span
                  >
                </template></el-table-column
              >
            </el-table>
          </div>
        </div>
        <div class="rightCenterDiv">
          <div class="rightCommonTitle">
            <div class="title"><i class="header-icon el-icon-remark"></i>&nbsp;备注</div>
            <div class="separator"></div>
          </div>
          <div class="remarkDiv">
            <div class="historyButton">
              <div
                v-if="!isConfirm"
                :class="!isHistory ? 'remarkClassNow' : 'remarkClassHistory'"
                @click="isHistory = false"
              >
                新增备注
              </div>
              <div
                :class="isHistory ? 'remarkClassNow' : 'remarkClassHistory'"
                @click="isHistory = true"
              >
                历史备注
              </div>
            </div>
            <div v-if="isHistory">
              <div class="historyRemark">
                <span v-for="(item, index) in note" :key="index"> {{ item }}<br /> </span>
              </div>
            </div>
            <div v-else-if="!isConfirm">
              <el-input
                style="height: 220px"
                placeholder="请输入备注(500字内，且不能输入$)"
                @input="change($event)"
                type="textarea"
                maxlength="500"
                v-model="flight.note"
              ></el-input>
            </div>
            <!-- <div :class="history">
              <div class="title">流转信息:</div>
              <div class="content">
                <span v-for="(item, index) in note" :key="index">
                  &nbsp; {{ item }}<br />
                </span>
              </div>
            </div>
            <div v-show="!isConfirm" class="seperate"></div>
            <el-input
              v-show="!isConfirm"
              type="textarea"
              v-model="flight.note"
              placeholder="请输入备注(500字内，且不能输入$)"
              maxlength="500"
              @input="change($event)"
            ></el-input> -->
          </div>
          <div class="relations">
            <el-checkbox-group v-model="relations">
              <el-checkbox
                :disabled="isConfirm"
                v-for="(item, index) in confirmRelations"
                :key="index"
                :label="item.id"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </div>
        <div class="rightBottomDiv" v-show="!isConfirm">
          <el-button class="saveButton" v-if="isDetail" @click="adopt()"> 通过</el-button>
          <el-button class="rejectButton" v-if="isDetail" @click="reject()">
            驳回</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import minimumer from "../../assets/img/home/minimumer.png";
import secondaryer from "../../assets/img/home/secondaryer.png";
import highester from "../../assets/img/home/highester.png";

import parkingApron1 from "../../assets/img/taskPlan/parkingApron1.png";
import parkingApron1Hover from "../../assets/img/taskPlan/parkingApron1Hover.png";
import parkingApron2 from "../../assets/img/taskPlan/parkingApron2.png";
import parkingApron2Hover from "../../assets/img/taskPlan/parkingApron2Hover.png";

import tooltipOver from "../tools/tooltipOver";
export default {
  name: "EnvironmentalGuarantee",
  props: ["userInfo"],
  data() {
    return {
      activeAccordionName: "deliveryTime", //当前打开的手风琴名称
      // 存储 计划流转信息
      planCirculationInfos: [],
      waitConfirmNum: 0,
      confirmNum: 0,
      rejectedNum: 0,
      opacityOfWaitConfirm: "opacity: 1;",
      opacityOfConfirm: "opacity: 0.4;",
      opacityOfRejected: "opacity: 0.4;",
      openTab: "waitConfirm",

      isConfirm: false,
      // 是否是查看详情
      isDetail: false,
      isHistory: false,

      rightTopDiv: "rightTopDiv",
      goodsListHeight: 235,

      history: "history",

      queryForm: {
        condition: "",
        flight_status: "", //10 规划中，15 已提交/待环境确认，20 待审核，30 驳回/审批拒绝，40 审批通过，50 待飞行，60 正在飞行，70 飞行结束，90 确认收货，
        IsConfirmed: 0, //0为待确认，1为已确认,-1已驳回
        currentpage: 1,
        pagesize: 0,
      },
      priorityClass: "",
      priority: null,

      taskPlanList: [],

      openedId: null, //已展开的任务
      flight: {}, // 计划信息
      applyer: {}, //提报人
      auditor: {}, //审核员
      customer_groundstaf: {}, //发货地勤
      destination_groundstaf: {}, //收货地勤
      flyer: {}, //飞手
      security: {}, //保障员
      task_controller: {}, //任务控制
      uav: { uavmodel: {} }, //无人机
      airlink: {}, //链路信息
      starstaypoint: {}, //起始驻点
      endstaypoint: {}, //结束驻点
      note: "",

      replaceStr: "$", //分隔符

      goodsName: "", //货物名称
      goodsList: [], //货物列表信息

      relations: [],
      // 确认关系
      confirmRelations: [
        {
          id: 0,
          label: "空域确认",
        },
        {
          id: 1,
          label: "气象确认",
        },
        {
          id: 2,
          label: "地理确认",
        },
        {
          id: 3,
          label: "电磁确认",
        },
      ],

      parkingApron1: parkingApron1,
      parkingApron1Hover: parkingApron1Hover,
      parkingApron2: parkingApron2,
      parkingApron2Hover: parkingApron2Hover,
    };
  },
  components: {
    "tooltip-over": tooltipOver,
  },
  methods: {
    change(e) {
      this.$forceUpdate();
      // 限制输入特殊字符$
      this.flight.note = e.replace(this.replaceStr, "");
    },
    showMore(val) {
      this.$confirm(val, "", {
        confirmButtonText: "好的",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        showCancelButton: false,
      });
    },
    // 环境保障统计接口
    getConfirmRelationStaticByEvnConfirmed() {
      this.getRequest(
        "/uav-task-server/confirmrelation/getConfirmRelationStaticByEvnConfirmed.do"
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          if (data) {
            this.waitConfirmNum = data.EvnWatingConfirm;
            this.confirmNum = data.EvnConfirmed;
            this.rejectedNum = data.EvnRejected;
          } else {
            this.waitConfirmNum = 0;
            this.confirmNum = 0;
            this.rejectedNum = 0;
          }
        } else if (oData.code != 401) {
          // let tips = "<i class='el-icon-warn-tip'></i>啊哦,计划统计获取失败~";
          // this.$confirm(tips, "提示", {
          //   confirmButtonText: "好的",
          //   customClass: "confirmClass-style",
          //   iconClass: "",
          //   confirmButtonClass: "confirm",
          //   dangerouslyUseHTMLString: true,
          //   showCancelButton: false,
          // });
        }
      });
    },
    waitConfirm() {
      if (this.openTab !== "waitConfirm") {
        this.opacityOfWaitConfirm = "opacity: 1;";
        this.opacityOfConfirm = "opacity: 0.4;";
        this.opacityOfRejected = "opacity: 0.4;";
        this.openedId = null;
        this.isDetail = false;
        this.isConfirm = false;
        this.isHistory = false;
        this.rightTopDiv = "rightTopDiv";
        this.history = "history";
        this.goodsListHeight = 235;
        this.queryForm.IsConfirmed = 0; //0为待确认，1为已确认,-1已驳回
        this.getConfirmRelationListByEvnConfirmed();
      }
      this.openTab = "waitConfirm";
    },
    confirm() {
      if (this.openTab !== "confirm") {
        this.opacityOfWaitConfirm = "opacity: 0.4;";
        this.opacityOfConfirm = "opacity: 1;";
        this.opacityOfRejected = "opacity: 0.4;";
        this.openedId = null;
        this.isDetail = false;
        this.isConfirm = true;
        this.isHistory = true;
        this.rightTopDiv = "rightConfirmTopDiv";
        this.history = "historyDiv";
        this.goodsListHeight = 293;
        this.queryForm.IsConfirmed = 1; //0为待确认，1为已确认,-1已驳回
        this.getConfirmRelationListByEvnConfirmed();
      }
      this.openTab = "confirm";
    },
    rejected() {
      if (this.openTab !== "rejected") {
        this.opacityOfWaitConfirm = "opacity: 0.4;";
        this.opacityOfConfirm = "opacity: 0.4;";
        this.opacityOfRejected = "opacity: 1;";
        this.openedId = null;
        this.isDetail = false;
        this.isConfirm = true;
        this.isHistory = true;
        this.rightTopDiv = "rightConfirmTopDiv";
        this.history = "historyDiv";
        this.goodsListHeight = 293;
        this.queryForm.IsConfirmed = -1; //0为待确认，1为已确认,-1已驳回
        this.getConfirmRelationListByEvnConfirmed();
      }
      this.openTab = "rejected";
    },
    // 环境保障列表查询
    getConfirmRelationListByEvnConfirmed() {
      const param = this.getQueryParam(this.queryForm);
      this.getRequest(
        "/uav-task-server/confirmrelation/getConfirmRelationListByEvnConfirmed.do?" +
          param
      ).then((res) => {
        let oData = res.data;
        if (0 == oData.code) {
          let data = oData.data;
          if (data) {
            this.taskPlanList = data.list;
          } else {
            this.taskPlanList = [];
          }
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>啊哦,环境保障列表获取失败~";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    choosePriority() {
      let priority = this.flight.priority;
      if (1 === priority) {
        this.priority = minimumer;
        this.priorityClass = "minimumer";
      } else if (2 === priority) {
        this.priority = secondaryer;
        this.priorityClass = "secondaryer";
      } else if (3 === priority) {
        this.priority = highester;
        this.priorityClass = "highester";
      }
    },
    clickTaskPlanRow(row) {
      this.activeAccordionName = "deliveryTime"; // 点击表格内计划信息时 重置 折叠面板
      this.openedId = row.id;
      this.setRelations(row);
      this.queryFlight(row.flight_id);
      this.isDetail = true;
      this.$refs.taskPlanList.toggleRowSelection(row);
    },
    // 根据id获取计划信息
    queryFlight(id) {
      this.getRequest("/uav-task-server/flight/queryFlight.do?id=" + id).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          if (data) {
            if (data.flight) {
              // 获取当前id计划的 计划流转信息
              this.planCirculationInfos = data.flight.plan_transfer_note
                ? JSON.parse(data.flight.plan_transfer_note)
                : [];

              this.flight = data.flight;
              if (!this.isEmptyStr(this.flight.task_coordinate_waypoints)) {
                const points = this.flight.task_coordinate_waypoints.split(";");
                this.flight.point_count = points.length;
              } else {
                this.flight.point_count = 0;
              }
            } else {
              this.flight = {};
            }
            let note = this.flight.note;
            if (note) {
              let notes = note.split(this.replaceStr);
              if (notes && notes.length > 0) {
                let notee = [];
                notes.forEach((item) => {
                  if (item) {
                    notee.push(item);
                  }
                });
                this.note = notee;
              } else {
                this.note = "";
              }
            } else {
              this.note = "";
            }
            this.flight.note = "";
            if (data.applyer) {
              this.applyer = data.applyer;
            } else {
              this.applyer = {};
            }
            if (data.auditor) {
              this.auditor = data.auditor;
            } else {
              this.auditor = {};
            }
            if (data.customer_groundstaf) {
              this.customer_groundstaf = data.customer_groundstaf;
            } else {
              this.customer_groundstaf = {};
            }
            if (data.destination_groundstaf) {
              this.destination_groundstaf = data.destination_groundstaf;
            } else {
              this.destination_groundstaf = {};
            }
            if (data.flyer) {
              this.flyer = data.flyer;
            } else {
              this.flyer = {};
            }
            if (data.lsgoods) {
              this.goodsList = data.lsgoods;
            } else {
              this.goodsList = [];
            }
            if (data.security) {
              this.security = data.security;
            } else {
              this.security = {};
            }
            if (data.task_controller) {
              this.task_controller = data.task_controller;
            } else {
              this.task_controller = {};
            }
            if (data.airlink) {
              this.airlink = data.airlink;
            } else {
              this.airlink = {};
            }
            if (data.starstaypoint) {
              this.starstaypoint = data.starstaypoint;
            } else {
              this.starstaypoint = {};
            }
            if (data.endstaypoint) {
              this.endstaypoint = data.endstaypoint;
            } else {
              this.endstaypoint = {};
            }
            if (data.uav) {
              this.uav = data.uav;
            } else {
              this.uav = { uavmodel: {} };
            }
            this.choosePriority();
            this.dealDataAfterGetDetail();
          }
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>啊哦,计划信息获取失败~";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    // 获取详情后 数据处理
    dealDataAfterGetDetail() {
      // 设置货物列表信息 start
      let goodsList = this.goodsList;
      if (goodsList && goodsList.length > 0) {
        let _this = this;
        this.goodsName = goodsList[0].goods_name;
        goodsList.forEach(function (goods, index) {
          let attributes = [];
          let goods_attribute_id = goods.goods_attribute_id;
          if (goods_attribute_id && 1 === Number(goods_attribute_id)) {
            attributes.push("易碎性");
          }
          let goods_explosible_id = goods.goods_explosible_id;
          if (goods_explosible_id && 1 === Number(goods_explosible_id)) {
            attributes.push("易爆性");
          }
          let goods_inflammable_id = goods.goods_inflammable_id;
          if (goods_inflammable_id && 1 === Number(goods_inflammable_id)) {
            attributes.push("易燃性");
          }
          let goods_cautery_id = goods.goods_cautery_id;
          if (goods_cautery_id && 1 === Number(goods_cautery_id)) {
            attributes.push("腐蚀性");
          }
          let attributesStr = "";
          for (let i = 0, len = attributes.length; i < len; i++) {
            if (i === len - 1) {
              attributesStr += attributes[i];
            } else {
              attributesStr += attributes[i] + ",";
            }
          }
          _this.$set(goods, "attributes", attributesStr); //触发更新视图
        });
        _this.goodsList = goodsList;
      } else {
        this.goodsList = [];
      }
    },
    changeCellStyle(row, column, rowIndex, columnIndex) {
      if (row.column.label === "优先级") {
        return "color:#FFA63E;padding: 0;"; //修改的样式
      } else {
        return "color:#FFFFFF;padding: 0;";
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (this.openedId === row.id) {
        return "focusRowStyle";
      }
      return "rowStyle";
    },
    goodsListRowClassName({ row, rowIndex }) {
      row.index = rowIndex + 1;
      return "rowStyle";
    },
    adopt() {
      let tips = null;
      let relations = this.relations;
      let flag = false;
      if (relations && relations.length > 0) {
        if (relations.indexOf(0) < 0) {
          flag = true;
          tips = "啊哦,请确认空域状态~";
        }
        if (!flag && relations.indexOf(1) < 0) {
          flag = true;
          tips = "啊哦,请确认气象状态~";
        }
        if (!flag && relations.indexOf(2) < 0) {
          flag = true;
          tips = "啊哦,请确认地理状态~";
        }
        if (!flag && relations.indexOf(3) < 0) {
          tips = "啊哦,请确认电磁状态~";
        }
      } else {
        tips = "啊哦,请确认空域状态~";
      }
      if (tips) {
        tips = "<i class='el-icon-warn-tip'></i>" + tips;
        this.$confirm(tips, "", {
          confirmButtonText: "好的",
          customClass: "confirmClass-style",
          iconClass: "",
          confirmButtonClass: "confirm",
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
        });
      } else {
        this.flight.flight_status = 20;
        this.flight.airspace_confirm = 1;
        this.flight.meteorology_confirm = 1;
        this.flight.geography_confirm = 1;
        this.flight.electromagnetism_confirm = 1;
        this.updateConfirmRelationEvnConfirmed();
      }
    },
    setRelations(row) {
      let relations = [];
      let airspace_confirm = row.airspace_confirm;
      if (1 === airspace_confirm) {
        relations.push(0);
      }
      let meteorology_confirm = row.meteorology_confirm;
      if (1 === meteorology_confirm) {
        relations.push(1);
      }
      let geography_confirm = row.geography_confirm;
      if (1 === geography_confirm) {
        relations.push(2);
      }
      let electromagnetism_confirm = row.electromagnetism_confirm;
      if (1 === electromagnetism_confirm) {
        relations.push(3);
      }
      this.relations = relations;
    },
    setValueByCheckBox() {
      let relations = this.relations;
      if (relations && relations.length > 0) {
        if (relations.indexOf(0) >= 0) {
          this.flight.airspace_confirm = 1;
        } else {
          this.flight.airspace_confirm = 0;
        }
        if (relations.indexOf(1) >= 0) {
          this.flight.meteorology_confirm = 1;
        } else {
          this.flight.meteorology_confirm = 0;
        }
        if (relations.indexOf(2) >= 0) {
          this.flight.geography_confirm = 1;
        } else {
          this.flight.geography_confirm = 0;
        }
        if (relations.indexOf(3) >= 0) {
          this.flight.electromagnetism_confirm = 1;
        } else {
          this.flight.electromagnetism_confirm = 0;
        }
      } else {
        this.flight.airspace_confirm = 0;
        this.flight.meteorology_confirm = 0;
        this.flight.geography_confirm = 0;
        this.flight.electromagnetism_confirm = 0;
      }
    },
    /**
     * 20 至计划审批环节 40 审批通过，
     */
    reject() {
      let note = this.flight.note;
      if (note) {
        this.flight.flight_status = 30;
        this.setValueByCheckBox();
        this.updateConfirmRelationEvnConfirmed();
      } else {
        let tips = "<i class='el-icon-warn-tip'></i>驳回时,需要填写备注哦~";
        this.$confirm(tips, "", {
          confirmButtonText: "好的",
          customClass: "confirmClass-style",
          iconClass: "",
          confirmButtonClass: "confirm",
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
        });
      }
    },
    updateConfirmRelationEvnConfirmed() {
      let tips = "<i class='el-icon-warn-tip'></i>是否确认该环境保障?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        dangerouslyUseHTMLString: true,
        cancelButtonClass: "cancel",
      })
        .then(() => {
          this.flight.id = this.openedId;
          this.postJsonRequest(
            "/uav-task-server/confirmrelation/updateConfirmRelationEvnConfirmed.do",
            this.flight
          ).then((res) => {
            let oData = res.data;
            if (oData.code === 0) {
              this.isDetail = false;
              this.getConfirmRelationStaticByEvnConfirmed();
              this.getConfirmRelationListByEvnConfirmed();
              this.$message({
                message: "操作成功",
                duration: 1000,
                customClass: "message-s",
                iconClass: "el-icon-ok-tip",
                offset: 470,
                onClose: function () {},
              });
            } else if (oData.code != 401) {
              let msg = "<i class='el-icon-warn-tip'></i>" + oData.msg;
              this.$confirm(msg, "提示", {
                confirmButtonText: "好的",
                customClass: "confirmClass-style",
                iconClass: "",
                confirmButtonClass: "confirm",
                dangerouslyUseHTMLString: true,
                showCancelButton: false,
              });
            }
          });
        })
        .catch((err) => {
        });
    },
  },
  mounted() {
    this.getConfirmRelationStaticByEvnConfirmed();
    this.$nextTick(function () {
      this.getConfirmRelationListByEvnConfirmed();
    });
    window.statisicsTimer = setInterval(
      this.getConfirmRelationStaticByEvnConfirmed,
      28000
    ); //28秒轮询一次
    window.queryTimer = setInterval(this.getConfirmRelationListByEvnConfirmed, 30000); //30秒轮询一次
  },
  beforeDestroy() {
    if (window.statisicsTimer) {
      clearInterval(window.statisicsTimer);
      window.statisicsTimer = null;
    }
    if (window.queryTimer) {
      clearInterval(window.queryTimer);
      window.queryTimer = null;
    }
  },
};
</script>

<style scoped>
@import "../../assets/css/home/EnvironmentalGuarantee.css";
</style>

<style>
.planCirculationTimelineBoxContent .planCirculationTimelineBoxContentInfo .el-timeline-item__content,
.planCirculationTimelineBoxContent .planCirculationTimelineBoxContentInfo .el-timeline-item__timestamp {
  text-align: left;
  font-size: 14px;
  font-family: ArialMT, AlibabaPuHuiTiR;
  color: #c1c1c1;
}
.planCirculationTimelineBoxContent .planCirculationTimelineBoxContentInfo .fontFFA63E .el-timeline-item__content,
.planCirculationTimelineBoxContent .planCirculationTimelineBoxContentInfo .fontFFA63E .el-timeline-item__timestamp {
  color: #ffa63e;
}
</style>



// WEBPACK FOOTER //
// src/components/home/EnvironmentalGuarantee.vue